<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش آموزشگاه ها</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/school/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت آموزشگاه جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                item-key="id"
                :headers="headers"
                :items="schools.data"
                :items-per-page="10"
                disable-sort
                expand-icon="mdi-chevron-up"
                hide-default-footer>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="error" @click="destroyInitial(item.id)">mdi-trash-can-outline
                </v-icon>
                <v-icon class="mx-1" color="warning" @click="edit(item.id)">mdi-pen
                </v-icon>
              </template>
              <template v-slot:[`item.is_visible`]="{ item }">
                <v-btn small :color="item.is_visible ? 'success' : 'error'" dark
                       class="normal-font-btn" @click="toggleVisibility(item)">
                  {{ item.is_visible ? 'نمایش' : 'عدم نمایش' }}
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="schools.current_page"
                :length="schools.last_page"
                circle
                @input="getSchools"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog width="50%" v-model="deleteSchoolDialog">
      <v-card>
        <v-card-actions>
          <v-icon color="error" @click="deleteSchoolDialog = false">mdi-close</v-icon>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              آیا از پاک کردن این آموزشگاه اطمینان دارید؟
            </v-col>
            <v-col cols="3"></v-col>
            <v-col cols="3">
              <v-btn color="warning" @click="destroy()">بله مطمعنم</v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn color="success" @click="deleteSchoolDialog = false">خیر منصرف شدم</v-btn>
            </v-col>
            <v-col cols="3"></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "SchoolIndexView",
  data() {
    return {
      loading: true,
      selectedItemId: null,
      deleteSchoolDialog: false,
      schools: {
        current_page: 1,
        data: []
      },
      headers: [
        {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
        {text: 'نام', value: 'name', align: 'center', width: '10%'},
        {text: 'لیبل', value: 'label', align: 'center', width: '10%'},
        {text: 'شارژ', value: 'charge', align: 'center', width: '10%'},
        {text: 'وضعیت نمایش', value: 'is_visible', align: 'center', width: '10%'},
        {text: 'اولویت نمایش', value: 'display_priority', align: 'center', width: '10%'},
        {text: 'عملیات', value: 'operation', align: 'center', width: '15%'},
      ],
    }
  },
  mounted() {
    this.getSchools()
  },
  methods: {
    getSchools() {
      let url = '/school/admin-index?page=' + (this.schools.current_page ?? 1) + '&per_page=10'
      window.axios.get(url).then((res) => {
        this.schools = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroyInitial(itemId) {
      this.selectedItemId = itemId;
      this.deleteSchoolDialog = true
    },
    destroy() {
      this.deleteSchoolDialog = false
      window.axios.delete('school/delete/' + this.selectedItemId).then(() => {
        this.getSchools()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    toggleVisibility(item) {
      const payload = {
        name: item.name,
        label: item.label,
        charge: item.charge,
        is_visible: !item.is_visible,
        display_priority: item.display_priority,
      }

      window.axios.post('school/update/' + item.id, payload).then(() => {
        item.is_visible = payload.is_visible
        this.openSnackbar("وضعیت نمایش آموزشگاه با موفقیت تغییر کرد.", 'success')
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    edit(itemId) {
      this.$router.push('/school/edit/' + itemId)
    }
  }
}
</script>

<style scoped>

</style>
